import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 36 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.85, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-3 text-[10px] sm:text-[11px] tracking-[0.38em] uppercase text-gold font-faith">
    <span className="h-px w-8 bg-gold/60" />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, sub }) => (
  <Reveal className="max-w-3xl">
    <Eyebrow>{eyebrow}</Eyebrow>
    <h2 className="mt-5 font-display text-2xl sm:text-3xl lg:text-4xl uppercase tracking-tight text-white leading-[1.05]">
      {title}
    </h2>
    {sub && <p className="mt-5 text-sm sm:text-base leading-relaxed text-slate-300">{sub}</p>}
  </Reveal>
);
